const API_VERSION = 'v2'

function getApiParams(host) {
	return {
		network: getNetwork(host),
		apiHost: '/api',
		apiVersion: API_VERSION,
	}
}

function getNetwork(host) {
	const hostParts = host.split('.')

	if (hostParts.length === 1) {
		return 'snatch'
	}

	if (hostParts.length === 3) {
		return hostParts[0]
	}

	if (hostParts.length === 4) {
		return hostParts[1]
	}
}

const { network, apiHost, apiVersion } = getApiParams(
	globalThis.window?.location.host ?? '',
)

const baseURL = `${apiHost}/${apiVersion}`

export { apiHost, apiVersion, baseURL, getApiParams, network }
